export default {
  state: {
    nowDate: null,            // 当前时间的时间戳
    timeDifference: 0,        // 和服务端时间差
    SubListUpdate: false,     // 任务的任务列表(子任务列表)是否更新
    subHeaderInfo: {},        // 子任务列表头部
    subList: [],              // 子任务列表
    activityMessage: 0,        // 活动广场小心数量
    timeDiff: 0, // 本地时间和服务器时间差
    hideGlobalHeader: false, // 活动详情页滚动后隐藏全局 Header
    // 考试答卷页（ExamPaper/ExamSystemPaper）是否允许展示全局头；默认 false，仅 pageSwitchTime==0 时由页面打开
    examAllowGlobalHeader: false,
    wyfFreeLoginReady: false  // WYF 免登录完成标志(成功/失败/异常都置 true，用于挂起 header-box 的公共接口)
  },
  mutations: {
    set_SubListUpdate (state) {
      state.SubListUpdate = !state.SubListUpdate
    },
    set_subHeaderInfo (state, val) {
      state.subHeaderInfo = val
    },
    set_nowDate (state, val) {
      state.nowDate = val
    },
    set_subList (state, val) {
      state.subList = val
    },
    set_timeDifference (state, val) {
      state.timeDifference = val
    },
    set_activityMessage (state, val) {
      state.activityMessage = val
    },
    setDiff (state, val) {
      state.timeDiff = val
    },
    set_hideGlobalHeader (state, val) {
      state.hideGlobalHeader = !!val
    },
    set_examAllowGlobalHeader (state, val) {
      state.examAllowGlobalHeader = !!val
    },
    set_wyfFreeLoginReady (state, val) {
      state.wyfFreeLoginReady = !!val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/common.js